import { Result } from 'antd';

/**
 * 没有 token 的访问一律落到这里。
 * 🔴 刻意不提示「请检查链接是否正确」之类的话 —— 这个站点对外只应通过完整链接访问，
 * 任何引导都可能让人去猜。
 */
export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f5f5f5',
      }}
    >
      <Result status="404" title="Page not found" />
    </div>
  );
}
